module.exports = __webpack_public_path__ + "static/media/10_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_sp.56981477.png";